import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async get(aprovacaoId: string) {
    const request = await api.get(`/aprovacoes/${aprovacaoId}`)
    return factory.build(request)
  },

  async getAprovacaoMedicoSecretaria(aprovacaoId: string) {
    const request = await api.get(`/aprovacoes/medico-secretaria/${aprovacaoId}`)
    return factory.build(request)
  },
}
